"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiseaseBox = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../atome");
const DiseaseBox_style_1 = require("./DiseaseBox.style");
function DiseaseBox({ active, icon, label, onPress, disabled = false, }) {
    return (react_1.default.createElement(react_native_1.View, { style: [DiseaseBox_style_1.styles.container] },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => onPress(), disabled: disabled, activeOpacity: 0.75, style: [DiseaseBox_style_1.styles.box, active ? DiseaseBox_style_1.styles.boxActive : DiseaseBox_style_1.styles.shadow] },
            react_1.default.createElement(react_native_1.View, { style: DiseaseBox_style_1.styles.iconContainer },
                react_1.default.createElement(atome_1.Icon, { icon: icon, active: active })),
            react_1.default.createElement(atome_1.Text, { style: [DiseaseBox_style_1.styles.text, active ? DiseaseBox_style_1.styles.textActive : {}] }, label))));
}
exports.DiseaseBox = DiseaseBox;
